//ThinkPreSchoolCard.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../../components/utils/Tooltip';
import './styles/CardFrame.css';
import './styles/BookShelf.css';
import cardframeimage from '../../assets/pageimages/cardframeimage.webp';

// import adImage from '../../assets/pageimages/bookworldlistad.webp';
// import sampleSound from "../../assets/sounds/sample.mp3"; 
import moreData from "./cardImageData.json";

const ThinkPreSchoolCard = () => {
    const tooltiptext = "About Think5Whys";

    const [isMore, setIsMore] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState("Sample");

    const freeData = [
        { category: "Animal", imageCode: "cow", imageName: "Cow", imageSrc: "cow.webp", hasSound: true, soundSrc: "cow.mp4" },
        { category: "Flower", imageCode: "rose", imageName: "Rose", imageSrc: "rose.webp", hasSound: false, soundSrc: "rose.mp4"},
        { category: "Vehicle", imageCode: "car", imageName: "Car", imageSrc: "car.webp", hasSound: false, soundSrc: "car.mp4" },
        { category: "Shape", imageCode: "star", imageName: "Star", imageSrc: "star.webp", hasSound: false, soundSrc: "star.mp4" },
        { category: "Fruit", imageCode: "apple", imageName: "Apple", imageSrc: "apple.webp", hasSound: false, soundSrc: "apple.mp4"  }
    ];

    const imageData = isMore ? moreData : freeData;

    const [selectedImage, setSelectedImage] = useState(imageData[0] || {}); 
    const [isSoundEnabled, setIsSoundEnabled] = useState(false);
    const audio = new Audio();
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [dragging, setDragging] = useState(false);

    const [touchStartX, setTouchStartX] = useState(null);
    const [touchStartY, setTouchStartY] = useState(null);

    const handleStart = (e, image) => {
        setDragging(false);
        const touch = e.touches?.[0] || e; 
        setTouchStartX(touch.clientX);
        setTouchStartY(touch.clientY);
    };

    const handleMove = (e) => {
        const touch = e.touches?.[0] || e;
        const deltaX = Math.abs(touch.clientX - touchStartX);
        const deltaY = Math.abs(touch.clientY - touchStartY);

        if (deltaX > 10 || deltaY > 10) {
            setDragging(true); 
        }
    };

    const handleEnd = (image) => {
        if (!dragging) {
            setSelectedImage(image); 
        }
    };

    const [smileyCount, setSmileyCount] = useState(0);
    const [lastClickTime, setLastClickTime] = useState(0);

    const handleImageClick = (image) => {
        const currentTime = Date.now();
        setSelectedImage(image);

        if (currentTime - lastClickTime >= 10000) {
            setSmileyCount((prev) => prev + 1);
            setLastClickTime(currentTime);
        }
    };

    const handleTouchStart = (e, image) => {
        setTouchStart(e.touches[0].clientX);
        setTouchEnd(null);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.touches[0].clientX);
    };

    const handleTouchEnd = (image) => {
        if (touchStart !== null && touchEnd === null) {
            setSelectedImage(image);
        }
    };

    const [giftSelected, setGiftSelected]=useState("starsticker");
    const handleGiftSelected = (item) => {
        setGiftSelected(item);
    };

    const toProperCase = (str) => {
        return str
          .split(/(?=[A-Z])|(?:[^a-zA-Z0-9 ])/g)  
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())  
          .join(' ');  
      };

    const handleEnableSound = () => {
        setIsSoundEnabled(!isSoundEnabled);
        handleSpeech();
    };

    const handleSpeech = () => {
        if (isSoundEnabled && selectedImage.hasSound) {
            const speech = new SpeechSynthesisUtterance("");
            speech.lang = "en-GB";
            speech.rate = 1;
            window.speechSynthesis.speak(speech);
        }
    };

    const handlePlaySound = () => {
        if (selectedImage.soundSrc) {
            const audio = new Audio(`/api/downloads/preschool/cards/sounds/${selectedImage.soundSrc}`);
            // console.log("audio ",audio);

            audio.play().catch(error => console.error("Error playing audio:", error));
        }
    };

    useEffect(() => {
        if (isSoundEnabled) {
            const speech = new SpeechSynthesisUtterance(selectedImage.imageName);
            speech.lang = "en-GB";
            speech.rate = 1;
            window.speechSynthesis.speak(speech);
        }
    }, [selectedImage, isSoundEnabled]);

    const filteredImages = selectedCategory
        ? imageData.filter((image) => image.category === selectedCategory)
        : imageData;

    const categories = [...new Set(imageData.map((image) => image.category))];

    return (
        <MainLayout>
            <div className="min-h-screen bg-blue-500 text-white flex flex-col items-center justify-start p-4 md:p-6 mt-12">
                <div className="bg-purple-700 w-full max-w-lg h-16 py-2 px-4 flex justify-center gap-2 md:gap-4 rounded-lg">
                    {["icecream", "toffee", "cupcake", "balloon", "starsticker"].map((gift) => (
                        <button
                            key={gift}
                            onClick={() => handleGiftSelected(gift)}
                            className="bg-blue-500 text-white h-10 w-10 md:w-12 md:h-12 text-2xl md:text-3xl rounded-lg shadow-md hover:bg-blue-700 flex items-center justify-center"
                        >
                            {gift === "icecream" && "🍦"}
                            {gift === "toffee" && "🍬"}
                            {gift === "cupcake" && "🧁"}
                            {gift === "balloon" && "🎈"}
                            {gift === "starsticker" && "🌟"}
                        </button>
                    ))}
                </div>

                <p className="text-lg md:text-xl">
                    Gift You Selected: <span className="text-yellow-200 font-semibold">{giftSelected}</span>
                </p>
                <p className="block text-sm font-medium text-yellow-200">
                    Reward: Earn 1 Smiley For Every Image Click in The Interval of Every Minimum 10 Seconds!! 
                </p>

                <div className="text-center text-lg font-semibold mt-2 text-yellow-400">
                    {Array(smileyCount).fill("😊").join(" ")}
                </div>

                <div>
                    {isMore && (
                        <div className="mb-4">
                            <select
                                id="category"
                                name="category"
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(e.target.value)}
                                className="mt-2 block w-full border-gray-300 shadow-sm rounded-md text-black"
                            >
                                <option value="Sample">Select Category</option>
                                {[...new Set(categories)].sort().map((category, index) => (
                                    <option key={index} value={category}>
                                        {category}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="grid grid-cols-5 sm:grid-cols-6 md:grid-cols-7 gap-1 md:gap-2 p-2 border-2 border-yellow-200 mt-4">
                        {filteredImages.map((image, index) => {
                            const isValidName = /^[A-Za-z0-9]$/.test(image.imageName);
                            return (
                                <div 
                                    key={index} 
                                    className="cursor-pointer text-center" 
                                    onClick={() => handleImageClick(image)}
                                >
                                    {isValidName ? (
                                        <p className="text-2xl md:text-2xl font-medium text-white px-2 py-2 mt-1">
                                            {image.imageName}
                                        </p>
                                    ) : (
                                    <img
                                        src={`/api/downloads/preschool/cards/${image.imageSrc}`}
                                        alt={image.imageName}
                                        className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-md border-4 border-yellow-400 shadow-lg hover:scale-110 transition-transform"
                                    />
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div
                    className="min-h-[90vh] relative flex flex-col justify-center items-center mt-2 md:mt-2 w-full max-w-md h-88 md:h-88 bg-cover bg-center rounded-lg shadow-lg"
                    style={{ backgroundImage: `url(${cardframeimage})` }}
                >
                    <p className="text-lg md:text-2xl font-semibold text-black">
                        {selectedImage.imageName}
                    </p>
                    {/^[A-Za-z0-9]$/.test(selectedImage.imageName) ? (
                            <p className="text-[144px] font-medium text-black mt-1">
                                {selectedImage.imageName}
                            </p>
                        ) : (
                        <img
                            id="cardframe-id"
                            src={`/api/downloads/preschool/cards/${selectedImage.imageSrc}`}
                            alt={selectedImage.imageName}
                            className="w-40 h-40 md:w-56 md:h-56 object-cover rounded-lg shadow-lg"
                        />
                    )}
                </div>

                <div className="bg-purple-700 w-full max-w-md h-16 py-2 px-4 flex justify-center gap-3 md:gap-4 mt-2 rounded-lg">
                    <button
                        onClick={handleEnableSound}
                        className="bg-blue-500 text-white h-10 w-10 md:w-12 md:h-12 text-2xl md:text-3xl rounded-lg shadow-md hover:bg-blue-700 flex items-center justify-center"
                    >
                        {isSoundEnabled ? "🔇" : "🔊"}
                    </button>
                    <div
                        className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${
                            isSoundEnabled ? "bg-green-500" : "bg-gray-500"
                        }`}
                    ></div>
                    <button
                        onClick={handlePlaySound}
                        className={`h-12 w-12 md:w-12 md:h-12 text-white px-2 text-2xl rounded-lg shadow-md ${
                            isSoundEnabled && selectedImage.hasSound
                                ? "bg-yellow-200 hover:bg-yellow-700"
                                : "bg-gray-400"
                        }`}
                        disabled={!isSoundEnabled || !selectedImage.hasSound}
                    >
                    🎵
                    </button>
                </div>
            </div>
        </MainLayout>
    );
};

export default ThinkPreSchoolCard;
